
import type { TranslationType } from 'i18n/type';

const data: TranslationType = {
  language: 'Thai',
  registration: {
    signUp: 'ลงทะเบียนเพื่อเข้าคิว',
    registerForm: {
      firstname: 'ชื่อ',
      lastname: 'นามสกุล',
      partySize: 'กลุ่มของท่านมีกี่คน',
      phoneNumber: 'หมายเลขโทรศัพท์',
      smsNotice: 'จะมีการส่ง SMS อัปเดตเกี่ยวกับสถานะคิวของท่านไปให้ที่หมายเลขโทรศัพท์นี้ ใช้อัตราค่าธรรมเนียมปกติ',
      reason: 'จุดประสงค์ในการเข้าชมร้านของท่านคืออะไร',
      otherReason: 'หากคำตอบเป็นอย่างอื่น โปรดระบุ',
      noOptions: 'No options',
      privacy: {
        confirm: 'เลือกช่องนี้เพื่อรับรองว่าหมายเลขที่ระบุเป็นหมายเลขของท่านเองและท่านยอมรับนโยบายความเป็นส่วนตัว',
        more: {
          title: 'ข้อมูลส่วนตัว',
          what: 'กุชชี่สามารถนำข้อมูลส่วนตัวของท่านไปใช้ได้อย่างไรบ้าง',
          details: {
            sl: '',
            balenciaga: '',
            gucci: 'บริษัท Guccio Gucci S.p.A. (\'Gucci\', \'ผู้ให้บริการ\') ในฐานะผู้ควบคุมข้อมูล มีความประสงค์ขอชี้แจงให้ทราบว่า การดำเนินการทางด้านข้อมูลของท่านที่ได้มอบให้กับทางองค์กร ด้วยวัตถุประสงค์ในการ: (i) จัดการระเบียบการลำดับให้บริการที่ทางเข้าของร้าน; และ (ii) ในกรณีที่ท่านมีข้อมูลอยู่ก่อนเข้าใช้บริการ หรือให้ข้อมูลเบื้องต้นในการเข้าใช้บริการ เพื่อเพิ่มประสิทธิภาพในการต้อนรับ การดำเนินการตามข้อมูลของท่านจะได้รับการดำเนินการโดยบุคลากรที่ได้รับอนุญาตตามกฎหมาย เพื่อให้บริการตามความต้องการของท่าน ทางองค์กรจะไม่นำข้อมูลส่วนตัวของท่าน ออกเผยแพร่หรือแจ้งข้อมูลใดๆ นอกเหนือขอบเขตการอนุญาตของ EEA หรือประเทศที่ได้รับการเก็บรวบรวมพื้นฐาน ไปยังบุคคลที่สาม ท่านสามารถใช้สิทธิ์ของท่านได้ตลอดเวลาตามกฎหมายความเป็นส่วนตัวที่ใช้บังคับ โดยการส่งอีเมลล์มาที่ privacy@gucci.com หากต้องการขอข้อมูลเพิ่มเติมเกี่ยวกับสิทธิ์ของท่านสามารถตรวจสอบได้ที่ลิงก์ต่อไปนี้ (<privacyLink>{{link}}</privacyLink>)',
            amq: '',
            brioni: '',
            bv: '',
          },
        },
      },
      countryCode: 'คำนำหน้าระหว่างประเทศ',
      signUp: 'ยืนยัน',
      errors: {
        required: 'ต้องระบุ',
        minLength: 'ต้องมีอักขระ {{val, number}} ตัวขึ้นไป',
        minNumberOfGuests: 'ต้องมีอย่างน้อย {{val, number}} ตัว',
        maxNumberOfGuests: 'ต้องมีสูงสุดไม่เกิน {{val, number}} ตัว',
        invalidCountryCode: 'รหัสประเทศไม่ถูกต้อง',
        invalidPhoneNumber: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
        privacy: 'ท่านต้องยอมรับข้อตกลง',
      },
    },
  },
  shared: {
    loading: 'กำลังโหลด...',
  },
  status: {
    accepted: 'ท่านได้รับการตอบรับให้เข้าชมร้านแล้ว',
    canceled: {
      confirm: 'ท่านถูกลบออกจากคิวเรียบร้อย ไว้พบกันใหม่คราวหน้า',
      thanks: '',
    },
    registered: {
      description:
      {
        part1: 'ขอบคุณ ตอนนี้ท่านเป็นคนต่อไปในคิวสำหรับ {{firstname}}!',
        part2: '',
        part3: '',
        part4: '',
      },
      next: 'ตอนนี้ถึงตาท่านเข้าร้านแล้ว! กรุณาสแกน QR Code ที่ทางเข้าร้าน',
      cancellation: 'ไม่สนใจเข้าชมร้านของเราแล้วใช่หรือไม่ <cancelLink>คลิกที่นี่เพื่อออกจากคิว</cancelLink>',
      cancel: {
        title: 'ออกจากคิว',
        body: 'หากออกจากคิวตอนนี้ ท่านจะเสียลำดับ',
        secondary: 'อยู่',
        primary: 'ออก',
      },
      register: {
        status: 'ลงทะเบียนเพื่อรับประสบการณ์ภายในร้านแบบส่วนตัวทุกครั้งที่ซื้อสินค้ากับเรา',
        button: 'ลงทะเบียนข้อมูลของฉัน',
      },
      bookAnAppointment: '<bookingLink>ลงทะเบียน</bookingLink>เพื่อไม่ต้องต่อคิวรอ',
    },
  },
  welcome: {
    language: 'ภาษา',
    info: 'ยินดีต้อนรับ มี {{count}} คนในคิวสำหรับ {{storeName}}',
    signUp: 'แตะที่ลงทะเบียนด้านล่างเพื่อเข้าคิว',
    action: 'ลงทะเบียน',
  },
  errors: {
    global: 'ขออภัย มีบางอย่างผิดพลาด',
    queueDisabled: 'ปิดรับคิวสำหรับ {{brand}} {{storeName}} แล้ว',
  },
};

export default data;
